export default "__VITE_ASSET__B71hAW8I__"